<div class="container" [ngClass]="{compact: isCompact, editing: isEditing}">
  <div class="message"
    [style.border-left-color]="chatMessage.isSystem && !(chatMessage.isDicebot || chatMessage.isCalculate) ? '#444444' : chatMessage.color"
    [style.border-right-color]="chatMessage.isSystem && !(chatMessage.isDicebot || chatMessage.isCalculate) ? '#444444' : chatMessage.color"
    [ngClass]="{'is-mine': isMine, 'is-others': !isMine, 'direct-message': (chatMessage.isDirect || chatMessage.isSecret), 'system-message': chatMessage.isSystem, 'dicebot-message': (chatMessage.isDicebot || chatMessage.isCalculate), 'operation-log': chatMessage.isOperationLog}"
    [@flyInOut]="isMine ? null : 'active'" [@flyInOutMe]="!isMine ? null : 'active'">
    <ng-container *ngIf="isMine && !isCompact">
      <ng-container *ngTemplateOutlet="image"></ng-container>
    </ng-container>
    <div class="body" [style.justify-content]="isCompact && !isMine ? 'flex-end' : 'flex-start'">
      <ng-container *ngIf="!isCompact || isMine">
        <ng-container *ngTemplateOutlet="title"></ng-container>
      </ng-container>
      <div class="text msg-text" [style.flex-grow]="isCompact && !isEditing ? 0 : 1" [ngClass]="{ 'is-success': (!chatMessage.isSecret || chatMessage.isSendFromSelf) && chatMessage.isSuccess, 'is-failure': (!chatMessage.isSecret || chatMessage.isSendFromSelf) && chatMessage.isFailure, 'is-critical': (!chatMessage.isSecret || chatMessage.isSendFromSelf) && chatMessage.isCritical, 'is-fumble': (!chatMessage.isSecret || chatMessage.isSendFromSelf) && chatMessage.isFumble }">
        <ng-container *ngIf="!chatMessage.isSecret || chatMessage.isSendFromSelf; then visible; else secret"></ng-container>
      </div>
      <div *ngIf="isEditable && isCompact">
        <ng-container *ngTemplateOutlet="editor"></ng-container>
      </div>
      <ng-container *ngIf="isCompact && !isMine">
        <ng-container *ngTemplateOutlet="title"></ng-container>
      </ng-container>
    </div>
    <ng-container *ngIf="!isMine && !isCompact">
      <ng-container *ngTemplateOutlet="image"></ng-container>
    </ng-container>
  </div>
</div>
<ng-template #image>
  <div class="image" [ngClass]="{inverse: chatMessage.isInverseIcon == 1, hollow: chatMessage.isHollowIcon == 1}">
    <span class="aura" [ngClass]="{black: chatMessage.aura == 0, blue: chatMessage.aura == 1, green: chatMessage.aura == 2, cyan: chatMessage.aura == 3, red: chatMessage.aura == 4, magenta: chatMessage.aura == 5, yellow: chatMessage.aura == 6, white: chatMessage.aura == 7}">
      <img *ngIf="0 < imageFile?.url?.length" [src]="imageFile?.url | safe: 'resourceUrl'" [ngClass]="{'black-paint': chatMessage.isBlackPaint == 1, 'face-icon': chatMessage.isFaceIcon }" />
    </span>
  </div>
</ng-template>
<ng-template #title>
  <div class="title">
    <ng-container *ngIf="isCompact && !isMine">
      <span class='tip msg-timestamp'>{{chatMessage.timestamp | date:'H:mm'}}</span>
    </ng-container>
    <span class="msg-name" [style.color]="!chatMessage.isSpecialColor && chatMessage.color && chatMessage.color != '#ffffff' ? chatMessage.color : ''">{{chatMessage.name}}</span>
    <ng-container *ngIf="!isCompact || isMine">
      <span *ngIf="!isCompact" class='tip msg-from' [innerHTML]="htmlEscapedFrom" (click)="onLinkClick($event)"></span>
      <span *ngIf="!isCompact" class='tip msg-timestamp'>{{chatMessage.timestamp | date:'y/M/d H:mm'}}</span>
      <span *ngIf="isCompact" class='tip msg-timestamp'>{{chatMessage.timestamp | date:'H:mm'}}</span>
      <ng-container *ngIf="!(isEditable && !isCompact); else editor"></ng-container>
    </ng-container>
  </div>
</ng-template>
<ng-template #visible>
  <div *ngIf="isEditing" style="position: relative">
    <span aria-hidden="true" style="visibility: hidden; display: inline-block">{{ lastNewLineAdjust(editingText) }}</span>
    <textarea #edit [(ngModel)]="editingText" style="position: absolute; top: 0px; left: 0px; width: 100%; height: 100%" (keydown.enter)="editEnd($event)" (keydown.escape)="editCancel()"></textarea>
  </div>
  <div [style.display]="isEditing ? 'none' : 'block'">
    <span style="display: inline-block">
      <span [style.color]="!chatMessage.isSpecialColor && chatMessage.color && chatMessage.color != '#ffffff' ? chatMessage.color : ''" 
        [innerHTML]="htmlEscapedText" (click)="onLinkClick($event)"></span>
      <span *ngIf="!isEditing && chatMessage.isEdited" class="is-edited"><b style="white-space: nowrap">編集済</b> {{chatMessage.lastUpdate | date:'M/d H:mm'}}</span>
      <button *ngIf="chatMessage.isSecret" (click)="discloseMessage()" style="padding-top: 1px; padding-bottom: 1px; margin-left: 3px;">結果を公開</button>
    </span>
  </div>
</ng-template>
<ng-template #secret>
  <span><s>（シークレットダイス）</s></span>
</ng-template>
<ng-template #editor>
  <span class="edit-buttons" [style.visibility]="isEditing ? 'visible' : ''" style="margin-left: 4px; white-space: nowrap">
    <button *ngIf="!isEditing" class="edit-button" (click)="editStart()" title="編集"><i class="material-icons small-font">edit</i></button>
    <button *ngIf="!isEditing" class="edit-button" aria-hidden="true" style="visibility: hidden"><i class="material-icons small-font">clear</i></button>
    <button *ngIf="isEditing" class="edit-button" [disabled]="editingText.trim().length == 0" (click)="editEnd()" title="確定"><i class="material-icons small-font">done</i></button>
    <button *ngIf="isEditing" class="edit-button" (click)="editCancel()" title="キャンセル"><i class="material-icons small-font">clear</i></button>
  </span>
</ng-template>
